import React from 'react';
import GuestBooksSlider from './ui/GuestBooksSlider';

function App() {
  return <GuestBooksSlider />;
}

export default App;